<template>
  <div class="secondary-menu-submenu">
    <a :id="id" href class="toggle" role="button" @click.prevent="toggle">
      {{ subMenu.text }}
      <span
        :class="[
          'af-icons',
          'af-icons-chevron-' + (isOpen ? 'down' : 'up'),
          'pull-right'
        ]"
      />
    </a>
    <collapsible>
      <ul v-if="isOpen" class="submenu" :aria-labelledby="id">
        <li v-for="item in subMenu.children" :key="item.name">
          <item
            :id="secondarySubmenuId(item)"
            :item="item"
            :current-url="currentUrl"
            @itemSelected="item => $emit('itemSelected', item)"
          />
        </li>
      </ul>
    </collapsible>
  </div>
</template>

<script>
import Collapsible from '../Shared/Collapsible';
import Item from './Item';

export default {
  components: {
    Collapsible,
    Item
  },
  props: {
    subMenu: {
      type: Object,
      default: () => ({})
    },
    currentUrl: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isOpen: true
    };
  },
  methods: {
    secondarySubmenuId(item) {
      return 'secondary-submenu-' + item.name;
    },
    toggle() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>
